(() => {
  if (window.__aliReviewsLoaded) return;
  window.__aliReviewsLoaded = true;

  const ROOT_SELECTOR = '[data-ali-reviews]';

  function normalizeReview(review) {
    return {
      id: review.id || '',
      productId: review.product_id || '',
      author: review.author || 'Anonymous',
      country: review.country || '',
      rating: Number(review.star) || 0,
      content: review.content || '',
      media: Array.isArray(review.media) ? review.media : [],
      createdAt: review.created_at || ''
    };
  }

  function formatDate(value, locale = 'en') {
    if (!value) return '';

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return '';
    }

    try {
      return new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }).format(date);
    } catch {
      return new Intl.DateTimeFormat('en', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }).format(date);
    }
  }

  function createStars(rating) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ali-review-card__stars';
    wrapper.setAttribute('aria-label', `${rating} out of 5 stars`);

    const starSvg = `
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false">
        <path d="M6.10312 8.80957L8.75508 8.1375L9.86308 11.5523L6.10312 8.80957ZM12.2062 4.3957H7.53809L6.10312 0L4.66816 4.3957H0L3.77813 7.12031L2.34316 11.516L6.12129 8.79141L8.44629 7.12031L12.2062 4.3957Z" fill="white"/>
      </svg>
    `;

    for (let i = 1; i <= 5; i += 1) {
      const star = document.createElement('span');
      star.className = 'ali-review-card__star';

      if (i > rating) {
        star.classList.add('is-empty');
      }

      star.innerHTML = starSvg;
      wrapper.appendChild(star);
    }

    return wrapper;
  }

  function getMediaModal() {
    let modal = document.querySelector('[data-ali-media-modal]');

    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'ali-media-modal';
    modal.dataset.aliMediaModal = '';
    modal.hidden = true;

    modal.innerHTML = `
      <div class="ali-media-modal__backdrop" data-ali-modal-close></div>

      <div
        class="ali-media-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Review image"
      >
        <button
          type="button"
          class="ali-media-modal__close"
          data-ali-modal-close
          aria-label="Close"
        >
          ×
        </button>

        <img
          class="ali-media-modal__image"
          data-ali-modal-image
          src=""
          alt=""
        >
      </div>
    `;

    document.body.appendChild(modal);

    modal
      .querySelectorAll('[data-ali-modal-close]')
      .forEach((element) => {
        element.addEventListener('click', closeMediaModal);
      });

    return modal;
  }

  function openMediaModal(src, alt = '') {
    if (!src) return;

    const modal = getMediaModal();
    const image = modal.querySelector('[data-ali-modal-image]');

    image.src = src;
    image.alt = alt;

    modal.hidden = false;

    requestAnimationFrame(() => {
      modal.classList.add('is-open');
    });

    document.body.classList.add('ali-media-modal-open');
  }

  function closeMediaModal() {
    const modal = document.querySelector('[data-ali-media-modal]');

    if (!modal) return;

    modal.classList.remove('is-open');
    document.body.classList.remove('ali-media-modal-open');

    setTimeout(() => {
      if (modal.classList.contains('is-open')) return;

      modal.hidden = true;

      const image = modal.querySelector('[data-ali-modal-image]');

      if (image) {
        image.src = '';
      }
    }, 200);
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMediaModal();
    }
  });

  function maskReviewerDetail(value) {
    const characters = Array.from(String(value || '').trim());
    return characters.length ? characters[0] + '*'.repeat(characters.length - 1) : '';
  }

  function createReviewCard(review, locale, hideReviewerDetails = false) {
    const displayAuthor = hideReviewerDetails ? maskReviewerDetail(review.author) : review.author;
    const card = document.createElement('article');
    card.className = 'ali-review-card';

    const top = document.createElement('div');
    top.className = 'ali-review-card__top';

    const bottom = document.createElement('div');
    bottom.className = 'ali-review-card__bottom';

    if (review.id) {
      card.dataset.reviewId = review.id;
    }

    top.appendChild(createStars(review.rating));

    if (review.content) {
      const content = document.createElement('p');
      content.className = 'ali-review-card__body';
      content.textContent = review.content;

      top.appendChild(content);
    }

    if (review.media.length) {
      const mediaWrapper = document.createElement('div');
      mediaWrapper.className = 'ali-review-card__media';

      review.media.slice(0, 2).forEach((item, index) => {
        const url =
          typeof item === 'string'
            ? item
            : item?.url || item?.src;

        if (!url) return;

        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'ali-review-card__media-button';

        const image = document.createElement('img');
        image.className = 'ali-review-card__thumb';
        image.src = url;
        image.alt = `Review photo ${index + 1}`;
        image.loading = 'lazy';

        button.appendChild(image);

        button.addEventListener('click', () => {
          openMediaModal(
            url,
            `Review photo by ${displayAuthor}`
          );
        });

        mediaWrapper.appendChild(button);
      });

      if (mediaWrapper.children.length) {
        bottom.appendChild(mediaWrapper);
      }
    }

    const footer = document.createElement('div');
    footer.className = 'ali-review-card__footer';

    const author = document.createElement('div');
    author.className = 'ali-review-card__author';

    const authorName = document.createElement('span');
    authorName.className = 'ali-review-card__author-name';
    authorName.textContent = displayAuthor;

    author.appendChild(authorName);

    if (review.country && !hideReviewerDetails) {
      const country = document.createElement('span');
      country.className = 'ali-review-card__country';
      country.textContent = review.country;

      author.appendChild(country);
    }

    const date = document.createElement('time');
    date.className = 'ali-review-card__date';
    date.textContent = formatDate(review.createdAt, locale);

    if (review.createdAt) {
      date.dateTime = review.createdAt;
    }

    footer.append(author, date);
    bottom.appendChild(footer);

    card.append(top, bottom);

    return card;
  }

  function updateArrows(list, prevButton, nextButton) {
    const maxScrollLeft = list.scrollWidth - list.clientWidth;
    const current = Math.round(list.scrollLeft);

    prevButton.disabled = current <= 0;
    nextButton.disabled = current >= Math.max(0, maxScrollLeft - 2);
  }

  function getScrollAmount(list) {
    const firstCard = list.querySelector('.ali-review-card');
    if (!firstCard) return list.clientWidth;

    const styles = window.getComputedStyle(list);
    const gap = parseFloat(styles.columnGap || styles.gap || 0);

    return firstCard.getBoundingClientRect().width + gap;
  }

  function getVisibleCards(list) {
    const styles = window.getComputedStyle(list);

    const visibleCards = Number.parseInt(
      styles.getPropertyValue('--ali-visible-cards'),
      10
    );

    return Number.isFinite(visibleCards)
      ? visibleCards
      : 4;
  }

  function setupCarousel(root) {
    const list = root.querySelector('[data-reviews-list]');
    const prevButton = root.querySelector('[data-reviews-prev]');
    const nextButton = root.querySelector('[data-reviews-next]');

    if (!list || !prevButton || !nextButton) return;

    const cards = list.querySelectorAll(
      '.ali-review-card:not(.ali-review-card--skeleton)'
    );

    const visibleCards = getVisibleCards(list);
    const shouldBeCarousel = cards.length > visibleCards;

    if (shouldBeCarousel) {
      list.classList.add('is-carousel');

      prevButton.hidden = false;
      nextButton.hidden = false;

      requestAnimationFrame(() => {
        updateArrows(list, prevButton, nextButton);
      });
    } else {
      list.classList.remove('is-carousel');
      list.scrollLeft = 0;

      prevButton.hidden = true;
      nextButton.hidden = true;
    }

    if (list.dataset.carouselBound === 'true') {
      return;
    }

    prevButton.addEventListener('click', () => {
      list.scrollBy({
        left: -getScrollAmount(list),
        behavior: 'smooth'
      });
    });

    nextButton.addEventListener('click', () => {
      list.scrollBy({
        left: getScrollAmount(list),
        behavior: 'smooth'
      });
    });

    list.addEventListener('scroll', () => {
      if (!list.classList.contains('is-carousel')) return;

      updateArrows(
        list,
        prevButton,
        nextButton
      );
    });

    const resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        setupCarousel(root);
      });
    });

    resizeObserver.observe(list);

    list.dataset.carouselBound = 'true';
  }

  async function loadReviews(root) {
    if (!root || root.dataset.aliInitialized === 'true') {
      return;
    }

    if (root.getAttribute("data-do-not-load-api") === "true") {
      const allMediaOpenButtons = document.querySelectorAll(".ali-reviews__inner .ali-review-card__media-button");

      allMediaOpenButtons.forEach((button) => {
        button.addEventListener("click", function () {
          const image = button.querySelector("img")
          const url = image ? image.src : null;
          const alt = image ? image.alt : null;

          if (!url) return;

          openMediaModal(
            url,
            `Review photo by ${alt || ""}`
          );
        });
      });

      requestAnimationFrame(() => {
        setupCarousel(root);
      });

      root.dataset.aliInitialized = 'true';
      return;
    }

    root.dataset.aliInitialized = 'true';

    const list = root.querySelector('[data-reviews-list]');
    const empty = root.querySelector('[data-empty-message]');
    const error = root.querySelector('[data-error-message]');

    const apiKey = root.dataset.apiKey?.trim();
    const apiUrl = root.dataset.apiUrl?.trim();
    const productId = root.dataset.productId?.trim();
    const pageType = root.dataset.pageType?.trim();
    const locale = root.dataset.locale || document.documentElement.lang || 'en';
    const limit = Number(root.dataset.limit) || 4;
    const hideReviewerDetails = root.dataset.hideReviewerDetails === 'true';

    if (!apiKey) {
      list.innerHTML = '';
      list.setAttribute('aria-busy', 'false');
      error.hidden = false;
      error.textContent = 'Ali Reviews API key is missing.';
      return;
    }

    try {
      const url = new URL(apiUrl);

      url.searchParams.set('limit', String(limit));
      url.searchParams.set('sort', 'by_date');
      url.searchParams.set('direction', 'desc');

      if (pageType === 'product' && productId) {
        url.searchParams.set('product_id', productId);
      }

      const response = await fetch(url.toString(), {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${apiKey}`
        }
      });

      if (!response.ok) {
        throw new Error(`Ali Reviews API HTTP ${response.status}`);
      }

      const payload = await response.json();
      const reviews = payload?.data?.reviews;

      if (!Array.isArray(reviews)) {
        throw new Error('Invalid Ali Reviews response');
      }

      list.innerHTML = '';
      list.setAttribute('aria-busy', 'false');

      if (!reviews.length) {
        empty.hidden = false;
        return;
      }

      reviews
        .slice(0, limit)
        .map(normalizeReview)
        .forEach((review) => {
          list.appendChild(createReviewCard(review, locale, hideReviewerDetails));
        });

      requestAnimationFrame(() => {
        setupCarousel(root);
      });
    } catch (err) {
      console.error('[Ali reviews]', err);

      list.innerHTML = '';
      list.setAttribute('aria-busy', 'false');
      error.hidden = false;

      const parentContainer = list.closest(".ali-reviews");

      if (parentContainer) {
        parentContainer.style.display = "none";
      }
    }
  }

  function init(scope = document) {
    if (scope.matches?.(ROOT_SELECTOR)) {
      loadReviews(scope);
    }

    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(loadReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
